module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba-funabashi-point2-1-259afa09ff14b4df21cece528e63758a.webp";